// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fv-a";
export var fulfillmentFormRail = "_fv-9";
export var headerTitleRow = "_fv-c";
export var orderDetailsWrapper = "_fv-7";
export var orderLinkTrigger = "_fv-2";
export var paymentInformationGrid = "_fv-h";
export var paymentSummaryColumn = "_fv-i";
export var shipmentContainer = "_fv-b";
export var shipmentDetailsMainPane = "_fv-8";
export var shipmentNavigationCard = "_fv-5";
export var shipmentNavigationRail = "_fv-3";
export var shipmentNavigationRailHeader = "_fv-4";
export var shipmentSummaryFact = "_fv-e";
export var shipmentSummaryGrid = "_fv-d";
export var shipmentSummaryMetadataRow = "_fv-f";
export var shipmentSummaryTags = "_fv-g";
export var shipmentWorkspace = "_fv-0";
export var shipmentWorkspaceContent = "_fv-6";
export var shipmentWorkspaceHeader = "_fv-1";